<div class="card-news">
    
    <div class="card-news-left">
        <div [innerHTML]="html" class="news-html"></div>
        <a *ngIf="linkTitle" class="btn prime" [href]="link">{{linkTitle}}</a>
        <div *ngIf="documents?.length" class="documents list default">
            <div class="items">
                <div class="item" *ngFor="let item of documents">
                <file-ico [type]="item.extension"></file-ico>
                <div class="value">
                    <a [href]="item.links?.open" target="_blank">{{item.name}}</a>
                    <div class="description">{{item.description}}</div>
                </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-news-right">
        <img [src]="image" alt="">
    </div>
</div>